import { Link, useLocation, Outlet } from "react-router-dom";
import {
  MessageSquare, Users, Video, CheckSquare, ArrowLeft, ChevronRight, Phone, Bot, Megaphone, Mail, Languages, Notebook, Globe
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar"
import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
import useTranslation from "@/hooks/useTranslation";

const NAV_ITEMS = (t) => [
  {
    id: "chat",
    label: t("Chat"),
    icon: MessageSquare,
    path: "/comms-centre/chat",
    description: t("Direct messaging")
  },
  {
    id: "groups",
    label: t("Group Chat"),
    icon: Users,
    path: "/comms-centre/groups",
    description: t("Team conversations")
  },
  {
    id: "calls",
    label: t("Calls"),
    icon: Phone,
    path: "/comms-centre/calls",
    description: t("Voice & video calls")
  },
  {
    id: "meetings",
    label: t("Meetings"),
    icon: Video,
    path: "/comms-centre/meetings",
    description: t("Video conferences")
  },
  {
    id: "tasks",
    label: t("Tasks Manager"),
    icon: CheckSquare,
    path: "/comms-centre/tasks",
    description: t("AI-powered task management")
  },
  {
    id: "noter",
    label: t("AllBaise Noter"),
    icon: Notebook,
    path: "/comms-centre/noter",
    description: t("Live meeting notetaker")
  },
  {
    id: "ai-pals",
    label: t("AI Pals"),
    icon: Bot,
    path: "/comms-centre/ai-pals",
    description: t("Communication analytics")
  },
  {
    id: "broadcast",
    label: t("Broadcast"),
    icon: Megaphone,
    path: "/comms-centre/broadcast",
    description: t("Org-wide announcements")
  },
  {
    id: "mail",
    label: t("Internal Mail"),
    icon: Mail,
    path: "/comms-centre/mail",
    description: t("Send & receive to any email address")
  },
  {
    id: "toloky",
    label: t("Toloky"),
    icon: Languages,
    path: "/comms-centre/toloky",
    description: t("AI interpreter & translation")
  }
];

export default function CommsCentreLayout() {
  const location = useLocation();
  const currentPath = location.pathname;
  const { t } = useTranslation();

  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS(t)}
        title="COMMS CENTRE"
        subtitle="Communication Hub"
        icon={MessageSquare}
        gradient="from-violet-500 to-purple-600"
        activeBg="bg-violet-500"
      />

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
